export const Api_Url = `https://cmsapi.scizers.com`
